export const services = [
  {
    id: 1,
    service_group: 'edr',
    service_group_label: 'mEDR (Endpoint Detection & Response)',
    service_group_icon: 'laptopOutlineIcon',
    service_group_icon_background: '#f3e5f5', // Light purple
    service_name: 'edr-connect',
    service_description: 'API Connect to SOAR - Alerting only',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 2,
    service_group: 'edr',
    service_group_label: 'mEDR (Endpoint Detection & Response)',
    service_group_icon: 'laptopOutlineIcon',
    service_group_icon_background: '#f3e5f5', // Light purple
    service_name: 'edr-complete',
    service_description: 'Full endpoint protection with advanced threat detection',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 3,
    service_group: 'edr',
    service_group_label: 'mEDR (Endpoint Detection & Response)',
    service_group_icon: 'laptopOutlineIcon',
    service_group_icon_background: '#f3e5f5', // Light purple
    service_name: 'edr-control',
    service_description: 'Endpoint control and management capabilities',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 4,
    service_group: 'edr',
    service_group_label: 'mEDR (Endpoint Detection & Response)',
    service_group_icon: 'laptopOutlineIcon',
    service_group_icon_background: '#f3e5f5', // Light purple
    service_name: 'edr-cmmc',
    service_description: 'CMMC Compliant Endpoint Protection',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 5,
    service_group: 'xdr',
    service_group_label: 'mXDR (Extended Detection & Response)',
    service_group_icon: 'securityCheckOutlineIcon',
    service_group_icon_background: '#e3f2fd', // Light blue
    service_name: 'xdr-standard',
    service_description: 'Standard Extended Detection & Response service',
    service_delivery_type: [
      {
        id: 1,
        name: 'connect',
        description: 'API Connect to SOAR - Alerting only',
      },
      {
        id: 2,
        name: 'complete',
        description: 'Full endpoint protection with advanced threat detection',
      },
      {
        id: 3,
        name: 'initiate',
        description: 'Endpoint detection and response capabilities',
      },
      {
        id: 4,
        name: 'o365',
        description: 'Office 365 detection and response capabilities',
      },
    ],
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 6,
    service_group: 'xdr',
    service_group_label: 'mXDR (Extended Detection & Response)',
    service_group_icon: 'securityCheckOutlineIcon',
    service_group_icon_background: '#e3f2fd', // Light blue
    service_name: 'xdr-govcloud',
    service_description: 'Government Cloud compliant XDR service',
    service_delivery_type: [
      {
        id: 1,
        name: 'connect',
        description: 'API Connect to SOAR - Alerting only',
      },
      {
        id: 2,
        name: 'complete',
        description: 'Full endpoint protection with advanced threat detection',
      },
      {
        id: 3,
        name: 'initiate',
        description: 'Endpoint detection and response capabilities',
      },
      {
        id: 4,
        name: 'o365',
        description: 'Office 365 detection and response capabilities',
      },
    ],
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 7,
    service_group: 'xdr',
    service_group_label: 'mXDR (Extended Detection & Response)',
    service_group_icon: 'securityCheckOutlineIcon',
    service_group_icon_background: '#e3f2fd', // Light blue
    service_name: 'xdr-cmmc',
    service_description: 'CMMC compliant Extended Detection & Response service',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 8,
    service_group: 'mes',
    service_group_label: 'mES (Email Security)',
    service_group_icon: 'envelopIcon',
    service_group_icon_background: '#e8f5e8', // Light green
    service_name: 'mes-basic',
    service_description: 'Core email security service',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 9,
    service_group: 'mes',
    service_group_label: 'mES (Email Security)',
    service_group_icon: 'envelopIcon',
    service_group_icon_background: '#e8f5e8', // Light green
    service_name: 'mes-advanced',
    service_description: 'Enhanced email security with advanced reporting',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 10,
    service_group: 'mes',
    service_group_label: 'mES (Email Security)',
    service_group_icon: 'envelopIcon',
    service_group_icon_background: '#e8f5e8', // Light green
    service_name: 'mes-complete',
    service_description: 'Complete email security with advanced reporting',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 11,
    service_group: 'vss',
    service_group_label: 'VSS (Vulnerability Scanning Service)',
    service_group_icon: 'bugOutlineIcon',
    service_group_icon_background: '#fff3e0', // Light orange
    service_name: 'vss-essential',
    service_description: 'Core vulnerability scanning service',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 12,
    service_group: 'vss',
    service_group_label: 'VSS (Vulnerability Scanning Service)',
    service_group_icon: 'bugOutlineIcon',
    service_group_icon_background: '#fff3e0', // Light orange
    service_name: 'vss-enhanced',
    service_description: 'Enhanced scanning with advanced reporting',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 13,
    service_group: 'professional',
    service_group_label: 'Professional Services',
    service_group_icon: 'userIcon',
    service_group_icon_background: '#fce4ec', // Light pink
    service_name: 'penetration-testing',
    pentest_type: [
      {
        id: 1,
        name: 'external',
        description: 'External penetration testing',
      },
      {
        id: 2,
        name: 'internal',
        description: 'Internal penetration testing',
      },
      {
        id: 3,
        name: 'webapp',
        description: 'Web application penetration testing',
      },
    ],
    service_description: 'Comprehensive security testing including external, internal, and web application assessments',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 14,
    service_group: 'professional',
    service_group_label: 'Professional Services',
    service_group_icon: 'userIcon',
    service_group_icon_background: '#fce4ec', // Light pink
    service_name: 'incident-response',
    service_description: '24/7 incident response services and threat hunting capabilities',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 15,
    service_group: 'professional',
    service_group_label: 'Professional Services',
    service_group_icon: 'userIcon',
    service_group_icon_background: '#fce4ec', // Light pink
    service_name: 'vciso',
    service_description: 'Virtual Chief Information Security Officer services and strategic guidance',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 16,
    service_group: 'professional',
    service_group_label: 'Professional Services',
    service_group_icon: 'userIcon',
    service_group_icon_background: '#fce4ec', // Light pink
    service_name: 'attack-surface-assessment',
    service_description: "Comprehensive analysis of your organization's digital attack surface",
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
  {
    id: 17,
    service_group: 'professional',
    service_group_label: 'Professional Services',
    service_group_icon: 'userIcon',
    service_group_icon_background: '#fce4ec', // Light pink
    service_name: 'breach-attack-assessment',
    breach_attack_type: [
      {
        id: 1,
        name: 'external',
        description: 'External breach attack assessment',
      },
      {
        id: 2,
        name: 'internal',
        description: 'Internal breach attack assessment',
      },
      {
        id: 3,
        name: 'webapp',
        description: 'Web application breach attack assessment',
      },
    ],
    service_description: 'Advanced threat simulation and breach readiness evaluation',
    service_status: 'active',
    service_created_at: '2021-01-01',
    service_updated_at: '2021-01-01',
  },
];

// Helper functions to get services by group
export const getServicesByGroup = (serviceGroup: string) => {
  return services.filter((service) => service.service_group === serviceGroup);
};

export const getEdrServices = () => getServicesByGroup('edr');
export const getMesServices = () => getServicesByGroup('mes');
export const getVssServices = () => getServicesByGroup('vss');
export const getXdrServices = () => getServicesByGroup('xdr');
export const getProfessionalServices = () => getServicesByGroup('professional');

// Helper function to convert service data to dropdown format
export const convertToDropdownFormat = (serviceList: typeof services) => {
  return serviceList.map((service) => ({
    value: service.service_name,
    text: service.service_name.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()),
    description: service.service_description,
    icon: service.service_group_icon,
    iconBackground: service.service_group_icon_background,
  }));
};

// Pre-converted dropdown formats for each service group
export const edrServiceOptions = convertToDropdownFormat(getEdrServices());
export const mesServiceOptions = convertToDropdownFormat(getMesServices());
export const vssServiceOptions = convertToDropdownFormat(getVssServices());
export const xdrServiceOptionsForDropdown = convertToDropdownFormat(getXdrServices());
export const professionalServiceOptions = convertToDropdownFormat(getProfessionalServices());

// Helper function to get delivery options for a specific XDR service
export const getXdrDeliveryOptions = (serviceName: string) => {
  const service = services.find((s) => s.service_name === serviceName);
  if (!service?.service_delivery_type) {
    return [];
  }

  return service.service_delivery_type.map((delivery) => ({
    value: delivery.name,
    text: delivery.name.charAt(0).toUpperCase() + delivery.name.slice(1),
    description: delivery.description,
  }));
};

// Helper function to get all unique delivery options from XDR services
export const getAllXdrDeliveryOptions = () => {
  const allDeliveryTypes = new Map();

  services
    .filter((service) => service.service_group === 'xdr' && service.service_delivery_type)
    .forEach((service) => {
      service.service_delivery_type?.forEach((delivery) => {
        if (!allDeliveryTypes.has(delivery.name)) {
          allDeliveryTypes.set(delivery.name, {
            value: delivery.name,
            text: delivery.name.charAt(0).toUpperCase() + delivery.name.slice(1),
            description: delivery.description,
          });
        }
      });
    });

  return Array.from(allDeliveryTypes.values());
};

// Legacy constant for backward compatibility (can be removed later)
export const xdrServiceOptions = getAllXdrDeliveryOptions();

// SLA options. Will come from Zenskar Data or SalesForce Data?
export const slaOptions = [
  { value: 'basic', text: 'Basic (8x5 Support)' },
  { value: 'standard', text: 'Standard (24x7 Support)' },
  { value: 'premium', text: 'Premium (24x7 + Dedicated)' },
  { value: 'enterprise', text: 'Enterprise (Custom SLA)' },
];

// Deployment options for XDR. Will come from Zenskar Data or SalesForce Data?
export const deploymentOptions = [
  { value: 'cloud', text: 'Cloud Deployment' },
  { value: 'on-premise', text: 'On-Premise Deployment' },
  { value: 'hybrid', text: 'Hybrid Deployment' },
];

// Appliance model options for XDR. Will come from Zenskar Data?
export const applianceModelOptions = [
  { value: 'sc-hw-160', text: 'SC-HW-160' },
  { value: 'sc-hw-250', text: 'SC-HW-250' },
  { value: 'sc-hw-500', text: 'SC-HW-500' },
  { value: 'sc-hw-1000', text: 'SC-HW-1000' },
];

// Virtual OS options for XDR. Will come from Zenskar Data?
export const virtualOSOptions = [
  { value: 'vmware', text: 'VMware ESXi' },
  { value: 'hyper-v', text: 'Microsoft Hyper-V' },
  { value: 'kvm', text: 'KVM' },
  { value: 'xen', text: 'Xen' },
];

// State options (can be shared across components). I believe we already have an endpoint for this?
export const stateOptions = [
  { value: 'AL', text: 'Alabama' },
  { value: 'AK', text: 'Alaska' },
  { value: 'AZ', text: 'Arizona' },
  { value: 'AR', text: 'Arkansas' },
  { value: 'CA', text: 'California' },
  { value: 'CO', text: 'Colorado' },
  { value: 'CT', text: 'Connecticut' },
  { value: 'DE', text: 'Delaware' },
  { value: 'FL', text: 'Florida' },
  { value: 'GA', text: 'Georgia' },
  { value: 'HI', text: 'Hawaii' },
  { value: 'ID', text: 'Idaho' },
  { value: 'IL', text: 'Illinois' },
  { value: 'IN', text: 'Indiana' },
  { value: 'IA', text: 'Iowa' },
  { value: 'KS', text: 'Kansas' },
  { value: 'KY', text: 'Kentucky' },
  { value: 'LA', text: 'Louisiana' },
  { value: 'ME', text: 'Maine' },
  { value: 'MD', text: 'Maryland' },
  { value: 'MA', text: 'Massachusetts' },
  { value: 'MI', text: 'Michigan' },
  { value: 'MN', text: 'Minnesota' },
  { value: 'MS', text: 'Mississippi' },
  { value: 'MO', text: 'Missouri' },
  { value: 'MT', text: 'Montana' },
  { value: 'NE', text: 'Nebraska' },
  { value: 'NV', text: 'Nevada' },
  { value: 'NH', text: 'New Hampshire' },
  { value: 'NJ', text: 'New Jersey' },
  { value: 'NM', text: 'New Mexico' },
  { value: 'NY', text: 'New York' },
  { value: 'NC', text: 'North Carolina' },
  { value: 'ND', text: 'North Dakota' },
  { value: 'OH', text: 'Ohio' },
  { value: 'OK', text: 'Oklahoma' },
  { value: 'OR', text: 'Oregon' },
  { value: 'PA', text: 'Pennsylvania' },
  { value: 'RI', text: 'Rhode Island' },
  { value: 'SC', text: 'South Carolina' },
  { value: 'SD', text: 'South Dakota' },
  { value: 'TN', text: 'Tennessee' },
  { value: 'TX', text: 'Texas' },
  { value: 'UT', text: 'Utah' },
  { value: 'VT', text: 'Vermont' },
  { value: 'VA', text: 'Virginia' },
  { value: 'WA', text: 'Washington' },
  { value: 'WV', text: 'West Virginia' },
  { value: 'WI', text: 'Wisconsin' },
  { value: 'WY', text: 'Wyoming' },
];

// Professional services specific options. Will come from Zenskar Data?
export const pentestTypeOptions = [
  { value: 'external', text: 'External' },
  { value: 'internal', text: 'Internal' },
  { value: 'webapp', text: 'Web Application' },
];

// Assessment package options. Will come from Zenskar Data?
export const assessmentPackageOptions = [
  { value: 'essential', text: 'Essential' },
  { value: 'advanced', text: 'Advanced' },
  { value: 'premium', text: 'Premium' },
];
